import React from 'react';

import Select from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import { BatchResults, SelectField } from '@scale/shared/types/geographic';
import { TaskBatchStatus } from '@scale/shared/defaults';

const SelectBatch = (props: {
  projectId: string | undefined;
  onChange: (b: any) => void;
  value: SelectField | undefined;
  status?: TaskBatchStatus;
  useMaxWidth?: boolean;
}) => {
  const { projectId, value, onChange, status, useMaxWidth } = props;

  const fetchBatches = async (search: any) => {
    try {
      const results = await apiFetch<BatchResults>(null, `corp-api/find/batches`, {
        query: { projectId, search, status },
      });

      const options = results.batches.map(batch => {
        return {
          label: `${batch.name} (${batch.id})`,
          value: batch.id,
        };
      });

      return {
        options,
      };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return [];
    }
  };

  return (
    <div style={{ width: useMaxWidth ? '100%' : 500 }}>
      <Select
        key={projectId}
        width={useMaxWidth ? '100%' : 500}
        value={value}
        onChange={onChange}
        placeholder={'select a batch'}
        loadOptions={fetchBatches}
        ignoreCase={false}
      />
    </div>
  );
};

SelectBatch.displayName = 'SelectBatch';

export default SelectBatch;
